import { TFunction } from 'react-i18next'

export class EstateNotFoundError extends Error {
  constructor(t: TFunction) {
    super(t('common.errors.estate.notFound'))
  }
}
